import { BaseBookingModel } from '@xeetr/types/models'
import { isFoodBookingModel } from '@xeetr/types/utils'
import { Calendar, Lock } from 'lucide-react'

import RecurringBadge from '@/components/commons/RecurringBadge'

export const NameColumn = (booking: BaseBookingModel) => {
  const name = `${booking.customer.firstName} ${booking.customer.lastName} ${
    booking.customer.companyName ? `(${booking.customer.companyName})` : ''
  }`
  if (isFoodBookingModel(booking)) {
    return (
      <div className="flex items-center gap-1">
        <span>{name}</span>
        {booking.closedSociety && <Lock className="h-3 w-3" />}
        {booking.eventParticipation && <Calendar className="h-3 w-3" />}
        {booking.seriesId && <RecurringBadge />}
      </div>
    )
  }

  return (
    <div className="flex items-center gap-1">
      <span>{name}</span>
      {booking.seriesId && <RecurringBadge />}
    </div>
  )
}
